export default {
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    loading: '加载中...',
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示'
  },
  
  // 导航
  nav: {
    home: '首页',
    Vision: '愿景',
    Platforms: '产品与平台',
    Services: '我们的服务',
    Cases: '案例',
    About: '关于',
    settings: '设置',
    profile: '个人资料',
    logout: '退出登录',
    contact: '联系我们'
  },
  txt: {
    t1: '让每一个流程更智能',
    t2: '企业级AI智能体 · 驱动业务革新',

    t4: 'AI赋能企业应用 · 引领智能化未来', 
    t41: '在数字化进入深水区的今天，AI正成为企业信息化系统的新引擎。', 
    t5: '通过将人工智能融入传统企业应用，企业可以让系统“理解”业务逻辑、“预测”决策趋势，并自动执行复杂流程，从而显著提升效率与创新能力。',
    t6: '亿循科技以自主研发的AI智能体平台为核心，将自然语言理解、知识图谱、RPA与数据智能等技术深度融合到企业场景中，让ERP、MES、CRM、财务、供应链等系统焕发智能化生命力。',
    t7: 'AI不再只是分析工具，而是企业运营的一部分——驱动从信息化到智能化的质变，让每一个流程更智能。',
    
    t9: '案例包括：中材科技、山东能源、延锋国际、万华化学、万达锅炉等。',

    t11: '基于ITIL标准的一站式企业应用托管服务，支持SAP与自研系统。',
    t12: '企业AI智能体托管、智能升级与迁移、版本迭代等服务。',

    t13: 'IF-AI · 亿循企业智能体平台',
    t14: 'IF-IDP · 智能单据处理系统',
    t15: 'IF-SCC · 供应链协同系统',
    t16: 'IF-IMS · 数字工厂管理系统',

    t17: '提供智能化解决方案咨询',
    t18: '从企业业务与战略目标出发，提供数字化转型与系统架构规划咨询。',
    t19: '亿循科技结合多年行业经验，为制造、能源、化工、高科技等领域定制可落地的智能化升级路线，实现从流程优化到系统集成的全方位提升。',
    t20: '实施企业应用系统建设',
    t21: '提供从系统设计、开发到交付的端到端企业级应用实施服务。',
    t22: '覆盖采购、生产、质量、财务、档案等核心业务模块，帮助企业构建高可靠、可扩展的信息化体系，提升运营效率与协同能力。',
    t23: '开发企业AI智能体应用',
    t24: '专注AI与企业业务深度融合，打造专属AI智能体平台。',
    t25: '通过自然语言交互、知识问答、流程自动化与数据洞察，为企业构建智能助手与智能决策系统，让业务流程更高效、更智能。',
    t26: '运维与优化企业应用系统',
    t27: '提供基于ITIL标准的一站式应用运维与系统优化服务。',
    t28: '支持SAP及自研系统的持续运行、升级与性能管理，同时为AI智能体系统提供智能维护与版本迭代，确保系统稳定、高效、可持续。',

    t29: '关于我们',
    t30: '杭州亿循科技有限公司，成立于2017年，是一家专注于企业信息化与智能化转型的国家高新技术企业。依托大数据、AI智能体、工业互联网、云计算等核心技术，致力于为企业提供从数字化管理到AI驱动决策的全栈式解决方案。经过多年的积淀，已为国内外十余家大型客户提供高质量的信息化项目实施服务，并长期承接多家企业的系统运维工作。服务行业涵盖能源、传统制造、化工与高科技等多个领域，与一些行业领军企业建立了稳定的合作关系。',
    
    // 新增：产品与平台（版块标题、简介与要点）
    pp_title: '以AI驱动业务革新，让企业每一个流程更智能。',
    pp_intro: '亿循科技通过自研智能平台与行业化产品，为企业提供从管理数字化到智能决策的一体化支撑。',
    core_features: '核心功能：',

    // IF-AI
    ai: {
      desc: '企业专属AI定制与托管平台，构建企业级智能核心，实现流程、数据与服务的全面智能化。',
      f1: '知识库问答平台 — 支持自然语言交互与知识检索',
      f2: '数据分析平台 — 多维度业务数据洞察与智能报告',
      f3: 'AI智能助手 — 跨系统协作与任务自动执行'
    },
    // IF-IDP
    idp: {
      desc: '让票据与档案管理更高效、更精准；基于OCR、RPA与知识图谱，实现单据处理自动化与全生命周期数字化。',
      f1: '自动识别与分类各类票据、档案',
      f2: '智能流转与审批，减少人工干预',
      f3: '支持票据全周期追踪与审计合规'
    },
    // IF-SCC
    scc: {
      desc: '打造高效协同的智能供应链生态，打通上下游，实现从订单到对账的全流程在线协作。',
      f1: '在线订单、发货、开票与对账管理',
      f2: '实时信息共享与流程追踪',
      f3: '多组织多角色协同与权限控制'
    },
    // IF-IMS
    ims: {
      desc: '融合AI与工业互联网，构建数字化、可视化的智能工厂，让制造更透明、更智能。',
      f1: '生产计划与进度智能调度',
      f2: '设备状态监测与维护预警',
      f3: '质量追溯与分析，助力精益制造'
    },
  },
  
  // 页面标题
  page: {
    home: '首页',
    about: '关于我们',
    welcome: '欢迎使用管理系统'
  },
  
  // 表单
  form: {
    username: '用户名',
    password: '密码',
    email: '邮箱',
    phone: '电话',
    name: '姓名',
    address: '地址',
    description: '描述',
    required: '此字段为必填项',
    invalidEmail: '请输入有效的邮箱地址',
    invalidPhone: '请输入有效的电话号码',
    minLength: '最少需要{min}个字符',
    maxLength: '最多允许{max}个字符'
  },
  
  // 消息
  message: {
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '退出成功',
    saveSuccess: '保存成功',
    deleteSuccess: '删除成功',
    updateSuccess: '更新成功',
    networkError: '网络连接错误',
    serverError: '服务器错误',
    unauthorized: '未授权访问',
    forbidden: '禁止访问',
    notFound: '页面不存在'
  }
}
